// Pure ordered-list operations for the reason-code editor (T-U3-010). Each
// returns a NEW array (never mutates) so React state updates cleanly.

export function addItem(items, value) {
  const v = (value ?? '').trim();
  if (!v) return items;
  return [...items, v];
}

export function removeItem(items, index) {
  return items.filter((_, i) => i !== index);
}

// Swap the item at `index` with its neighbour in direction `dir` (-1 up, +1 down).
// Out-of-range moves are no-ops (returns the same array reference).
export function moveItem(items, index, dir) {
  const j = index + dir;
  if (j < 0 || j >= items.length) return items;
  const next = items.slice();
  [next[index], next[j]] = [next[j], next[index]];
  return next;
}
